import BedSensor from './BedSensorContainer'

export default BedSensor
